import React from "react";
import ReactDOM from "react-dom";

export default class Portal extends React.Component {
  constructor(props) {
    super(props);
    this.portalNode = document.createElement("div");
  }

  componentDidMount() {
    document.body.appendChild(this.portalNode);
  }

  componentWillUnmount() {
    document.body.removeChild(this.portalNode);
  }

  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.portalNode
    );
  }
}
